import { render, staticRenderFns } from "./TableParams.vue?vue&type=template&id=70539cc6&"
import script from "./TableParams.vue?vue&type=script&lang=js&"
export * from "./TableParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports